import * as React from "react";

const LoadMore: React.FC<{
  onClick: () => void;
}> = ({ onClick }) => {
  return (
    <>
      <div className="text-center">
        <button
          className="button button__gradient"
          name="load_more"
          type="button"
          onClick={onClick}
          style={{ maxWidth: "250px" }}
        >
          Load More Deals
        </button>
      </div>
    </>
  );
};

export default LoadMore;
